(() => {
  const hideInlineMeasurements = (root = document) => {
    root.querySelectorAll('.pb-product-description__content').forEach(description => {
      description.querySelectorAll('h2,h3').forEach(heading => {
        if (!/^(product measurements|size chart|size guide)$/i.test(heading.textContent.trim())) return;
        const card = heading.closest('.pb-card,.card,section');
        const independentHeading = card && Array.from(card.querySelectorAll('h2,h3')).some(node => node !== heading && !node.closest('.size-card'));
        if (card && description.contains(card) && !independentHeading) {
          card.setAttribute('data-pb-inline-size-hidden', '');
          return;
        }
        let node = heading;
        const headingLevel = Number(heading.tagName.slice(1));
        while (node) {
          if (node !== heading && /^H[1-6]$/.test(node.tagName) && Number(node.tagName.slice(1)) <= headingLevel) break;
          const next = node.nextElementSibling;
          node.setAttribute('data-pb-inline-size-hidden', '');
          node = next;
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hideInlineMeasurements(), {once: true});
  } else {
    hideInlineMeasurements();
  }
  document.addEventListener('shopify:section:load', event => hideInlineMeasurements(event.target));
})();
(() => {
  const populateCare = (root = document) => {
    root.querySelectorAll('.pb-product-accordions').forEach(accordion => {
      const description = accordion.querySelector('.pb-product-description__content');
      const content = accordion.querySelector('[data-pb-care-content]');
      if (!description || !content || content.dataset.pbCareReady) return;
      const instructions = new Set();
      const add = node => {
        const text = node.textContent.trim();
        if (text) instructions.add(text);
        node.setAttribute('data-pb-care-hidden', '');
      };
      description.querySelectorAll('h2,h3,h4').forEach(heading => {
        if (!/^(care|care instructions|fabric care|washing instructions)$/i.test(heading.textContent.trim())) return;
        const level = Number(heading.tagName.slice(1));
        let node = heading.nextElementSibling;
        const nodes = [];
        while (node && !(/^H[1-6]$/.test(node.tagName) && Number(node.tagName.slice(1)) <= level)) {
          nodes.push(node);
          node = node.nextElementSibling;
        }
        if (nodes.length) {
          heading.setAttribute('data-pb-care-hidden', '');
          nodes.forEach(add);
        }
      });
      description.querySelectorAll('li, div, tr').forEach(row => {
        if (row.hasAttribute('data-pb-care-hidden')) return;
        const label = row.firstElementChild;
        if (!label || !/^(care|care instructions):?$/i.test(label.textContent.trim())) return;
        const value = row.textContent.trim().replace(/^care(?: instructions)?\s*:?\s*/i, '').trim();
        if (value) {
          instructions.add(value);
          row.setAttribute('data-pb-care-hidden', '');
        }
      });
      description.querySelectorAll('li,p').forEach(row => {
        if (row.closest('[data-pb-care-hidden]')) return;
        const text = row.textContent.trim();
        if (!/^care instructions\s*:/i.test(text)) return;
        instructions.add(text.replace(/^care instructions\s*:\s*/i, ''));
        row.setAttribute('data-pb-care-hidden', '');
      });
      if (instructions.size) {
        content.replaceChildren(...Array.from(instructions, text => {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          return paragraph;
        }));
      }
      content.dataset.pbCareReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => populateCare(), {once: true});
  else populateCare();
  document.addEventListener('shopify:section:load', event => populateCare(event.target));
})();
